import {GA4EventName, GA4EventParamName, trackGA4CustomEvent} from '@Libraries/ga-events';
import type {QRCopyResult} from '@Components/qr-code-generator/qr-generator-tracking.library';
import type {UtmDesignSelection, UtmFieldCheckResult, UtmFormFieldName, UtmLinkState} from './utm-link-builder.types';

// Each event sends every parameter it has, every time: GTM keeps an earlier event's value for any parameter an event leaves out.

export const trackUtmFieldFilled = (fieldName: UtmFormFieldName, checkResult: UtmFieldCheckResult): void => {
  trackGA4CustomEvent(GA4EventName.UTM_TOOL_FIELD_FILLED, {
    [GA4EventParamName.NAME]: fieldName,
    [GA4EventParamName.RESULT]: checkResult,
  });
};

export const trackUtmCopy = (copyResult: QRCopyResult, parameterCount: number): void => {
  trackGA4CustomEvent(GA4EventName.UTM_TOOL_COPY, {
    [GA4EventParamName.RESULT]: copyResult,
    [GA4EventParamName.VALUE]: String(parameterCount),
  });
};

export const trackUtmDesignSelected = ({linkState, designHashedId, position}: UtmDesignSelection): void => {
  trackGA4CustomEvent(GA4EventName.UTM_TOOL_DESIGN_SELECTED, {
    [GA4EventParamName.TYPE]: linkState,
    [GA4EventParamName.HASHED_ID]: designHashedId,
    [GA4EventParamName.POSITION]: String(position),
  });
};

export const trackUtmGalleryClick = (linkState: UtmLinkState): void => {
  trackGA4CustomEvent(GA4EventName.UTM_TOOL_GALLERY_CLICK, {[GA4EventParamName.TYPE]: linkState});
};
